module.exports = __webpack_public_path__ + "media/images/front/icon_youtube-2604a46d9cf4a2601d80fcbc76ccc522.png";